import React from 'react';
import { Modal } from 'antd';
import 'antd/es/modal/style/index.css'
import './modal.css'

const AntdModal = ({ ...props }) => {
  const {
    children,
    header,
    afterLogInNotification,
    ...rest
  } = props

  let customClass = "";

  if(afterLogInNotification){
    customClass = "afterLogInNotification";
    if(header === null){
      customClass = "afterLogInNotification hide-header";
    }
  }

  return (
    <Modal
      {...rest}
      className={customClass}
    >
      {children}
    </Modal>
  )
}

export default AntdModal;
